var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useVirtual from 'react-cool-virtual';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppSelector } from '../../store';
import ParticipantComponent from './participant';
import { participantsSelector } from '../../store/slices/participantSlice';
import RemoveParticipantAlertModal from './removeParticipantAlertModal';
const screenHeightSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.screenHeight);
$RefreshReg$(_react_refresh_temp_1, "screenHeightSelector$createSelector");
const ParticipantsComponent = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    _react_refresh_temp_3();
    const { t } = useTranslation();
    const allParticipants = useAppSelector(participantsSelector.selectAll);
    const screenHeight = useAppSelector(screenHeightSelector);
    const [participants, setParticipants] = useState([]);
    const { outerRef, innerRef, items } = useVirtual({
        itemCount: participants.length,
    });
    const [removeParticipantData, setRemoveParticipantData] = useState();
    const session = store.getState().session;
    const currentUserUserId = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.userId;
    const allow_view_other_users_list = (_d = (_c = (_b = session.currentRoom.metadata) === null || _b === void 0 ? void 0 : _b.room_features) === null || _c === void 0 ? void 0 : _c.allow_view_other_users_list) !== null && _d !== void 0 ? _d : false;
    const currentIsAdmin = (_g = (_f = (_e = session.currentUser) === null || _e === void 0 ? void 0 : _e.metadata) === null || _f === void 0 ? void 0 : _f.is_admin) !== null && _g !== void 0 ? _g : false;
    useEffect(() => {
        if (!allParticipants) {
            return;
        }
        setParticipants(allParticipants.filter((p) => p.name !== '' &&
            p.userId !== 'RECORDER_BOT' &&
            p.userId !== 'RTMP_BOT'));
    }, [allParticipants]);
    const onOpenRemoveParticipantAlert = (name, user_id, type) => {
        setRemoveParticipantData({
            name,
            userId: user_id,
            removeType: type,
        });
    };
    const onCloseAlertModal = () => {
        setRemoveParticipantData(undefined);
    };
    const renderParticipant = (index) => {
        if (!participants.length || typeof participants[index] === 'undefined') {
            return null;
        }
        const participant = participants[index];
        const isRemoteParticipant = currentUserUserId !== participant.userId;
        if (!currentIsAdmin && !allow_view_other_users_list) {
            if (!participant.metadata.is_admin &&
                currentUserUserId !== participant.userId) {
                return null;
            }
        }
        return (_jsx(ParticipantComponent, { participant: participant, isRemoteParticipant: isRemoteParticipant, openRemoveParticipantAlert: onOpenRemoveParticipantAlert }, participant.sid));
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "inner-wrapper relative z-20", children: [_jsx("div", { className: "top flex items-center justify-between font-medium mb-3 xl:mb-5", children: _jsx("p", { className: "text-sm text-black dark:text-white", children: t('left-panel.participants', {
                                total: participants.length,
                            }) }) }), _jsx("div", { ref: outerRef, style: { height: screenHeight - 215, overflow: 'auto' }, className: "-mx-2 xl:-mx-4 scrollBar", children: _jsx("div", { className: "all-participants-wrap px-2 xl:px-4", ref: innerRef, children: items.map(({ index, measureRef }) => (_jsx("li", { ref: measureRef, className: "mb-3 w-full list-none", children: renderParticipant(index) }, index))) }) })] }), removeParticipantData ? (_jsx(RemoveParticipantAlertModal, { name: removeParticipantData.name, userId: removeParticipantData.userId, removeType: removeParticipantData.removeType, closeAlertModal: onCloseAlertModal })) : null] }));
};
_react_refresh_temp_2 = ParticipantsComponent;
$RefreshReg$(_react_refresh_temp_2, "ParticipantsComponent");
_react_refresh_temp_3(ParticipantsComponent, "KsRYF7WMIopWKAZpD+jc62KAN9s=", false, () => [useTranslation, useAppSelector, useAppSelector, useVirtual]);
export default ParticipantsComponent;
